import { Leaf, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { DISHES } from "@/assets";

export const Menu = () => {
  const { t } = useLang();
  return (
    <section id="menu" className="py-20 md:py-28 bg-white" data-testid="menu-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <SectionHead label={t.menu.label} title={t.menu.title} subtitle={t.menu.subtitle} />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {DISHES.map((d, i) => (
            <Reveal key={i} delay={(i % 4) * 0.06}>
              <div className="card overflow-hidden h-full group hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(0,0,0,0.18)]" data-testid={`dish-${i}`}>
                <div className="relative h-52 overflow-hidden">
                  <img src={d.img} alt={d.name} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-testid={`dish-image-${i}`} />
                  <span className="absolute top-3 right-3 bg-white rounded-full px-3 py-1 text-sm font-bold text-ink shadow">€ {d.price}</span>
                </div>
                <div className="p-5">
                  <h3 className="font-display font-bold text-base text-ink">{d.name}</h3>
                  <p className="mt-2 text-sm text-muted leading-relaxed">{t.menu.desc[i]}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col md:flex-row items-center justify-between gap-6 rounded-3xl bg-tricolor-green/[0.06] border border-tricolor-green/20 p-6 md:p-8">
            <p className="flex items-center gap-2 text-ink font-medium text-center md:text-left">
              <Leaf size={20} className="text-tricolor-green flex-shrink-0" />
              {t.menu.subtitle}
            </p>
            <a href="#franchise" className="btn-primary flex-shrink-0" data-testid="menu-order-cta">
              {t.menu.order} <ArrowRight size={18} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
